module.exports = __webpack_public_path__ + "img/x.c3d10623.svg";